export const SUPPORT_TELEGRAM_LINK = 'https://t.me/PayPartners_Support';

export enum SupportIssueType {
  Technical = 'technical',
  Financial = 'financial',
}
